import { Subscription } from 'rxjs';
import { ExportInterfaceConfigurationDay, ExportInterfaceConfigurationDetailsTimeScheduleDTO } from '../../../../../base/models/models.swagger.generated';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AbstractControlOptions, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { startWith } from 'rxjs/operators';
import { ConfigurationFormTimeplanValidators } from './configuration-form-timeplan.validators';
import { TranslateModule } from '@ngx-translate/core';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgClass } from '@angular/common';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { DatePickerModule, MaskedDateTimeService, TimePickerModule } from '@syncfusion/ej2-angular-calendars';

@Component({
    selector: 'app-configuration-form-timeplan',
    templateUrl: './configuration-form-timeplan.component.html',
    styleUrls: ['./configuration-form-timeplan.component.scss'],
    imports: [ReactiveFormsModule, DatePickerModule, AppErrorMessagesComponent, YesNoGroupButtonComponent, NgClass, TimePickerModule, NumericTextBoxModule, TranslateModule],
    providers: [MaskedDateTimeService]
})
export class ConfigurationFormTimeplanComponent implements OnInit, OnDestroy {
  @Input() public data: ExportInterfaceConfigurationDetailsTimeScheduleDTO;

  public get configurationFormTimeplan(): UntypedFormGroup {
    return this.configurationFormService.configurationFormTimeplan;
  }

  public allWeekdays = this.fb.group({
    allowedMonday: [false],
    allowedTuesday: [false],
    allowedWednesday: [false],
    allowedThursday: [false],
    allowedFriday: [false],
    allowedSaturday: [false],
    allowedSunday: [false],
  }, {validators: [ConfigurationFormTimeplanValidators.allWeekdaysValidator]} as AbstractControlOptions);

  private subscriptions: Subscription = new Subscription();

  constructor(
    private configurationFormService: ConfigurationFormCoordinatorService,
    private fb: UntypedFormBuilder) {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.subscriptions.add(this.configurationFormService.configurationDetailsDTOUpdated.subscribe(data => {
      this.onConfigurationChanged();
    }));
    this.onConfigurationChanged();

    this.subscriptions.add(
      this.allWeekdays.valueChanges.subscribe(() => {
      let count: number = 0;
      if (this.allWeekdays.get('allowedMonday').value) {
        count += ExportInterfaceConfigurationDay.Monday;
      }
      if (this.allWeekdays.get('allowedTuesday').value) {
        count += ExportInterfaceConfigurationDay.Tuesday;
      }
      if (this.allWeekdays.get('allowedWednesday').value) {
        count += ExportInterfaceConfigurationDay.Wednesday;
      }
      if (this.allWeekdays.get('allowedThursday').value) {
        count += ExportInterfaceConfigurationDay.Thursday;
      }
      if (this.allWeekdays.get('allowedFriday').value) {
        count += ExportInterfaceConfigurationDay.Friday;
      }
      if (this.allWeekdays.get('allowedSaturday').value) {
        count += ExportInterfaceConfigurationDay.Saturday;
      }
      if (this.allWeekdays.get('allowedSunday').value) {
        count += ExportInterfaceConfigurationDay.Sunday;
      }
      this.configurationFormTimeplan.get('weekDays').setValue(count);
    }));

    this.configurationFormTimeplan.get('hasEndDate').valueChanges
      .pipe(
        startWith(this.configurationFormTimeplan.get('hasEndDate').value),
      )
      .subscribe(hasEndDate => {
        if (hasEndDate) {
          this.configurationFormTimeplan.get('endDate').setValidators([Validators.required]);
          this.configurationFormTimeplan.get('endDate').enable();
        } else {
          this.configurationFormTimeplan.get('endDate').setValidators([]);
          this.configurationFormTimeplan.get('endDate').setValue(null);
          this.configurationFormTimeplan.get('endDate').disable();
        }
        this.configurationFormTimeplan.get('endDate').updateValueAndValidity();
        this.configurationFormTimeplan.updateValueAndValidity();
      });
  }

  public selectAllDays() {
    this.allWeekdays.setValue({
      allowedMonday: true,
      allowedTuesday: true,
      allowedWednesday: true,
      allowedThursday: true,
      allowedFriday: true,
      allowedSaturday: true,
      allowedSunday: true
    });
  }

  public selectWorkingDays() {
    this.allWeekdays.setValue({
      allowedMonday: true,
      allowedTuesday: true,
      allowedWednesday: true,
      allowedThursday: true,
      allowedFriday: true,
      allowedSaturday: false,
      allowedSunday: false
    });
  }

  private onConfigurationChanged() {
    const weekdays = this.configurationFormTimeplan.get('weekDays').value;
    this.allWeekdays.setValue({
      allowedMonday: !!(weekdays & ExportInterfaceConfigurationDay.Monday),
      allowedTuesday: !!(weekdays & ExportInterfaceConfigurationDay.Tuesday),
      allowedWednesday: !!(weekdays & ExportInterfaceConfigurationDay.Wednesday),
      allowedThursday: !!(weekdays & ExportInterfaceConfigurationDay.Thursday),
      allowedFriday: !!(weekdays & ExportInterfaceConfigurationDay.Friday),
      allowedSaturday: !!(weekdays & ExportInterfaceConfigurationDay.Saturday),
      allowedSunday: !!(weekdays & ExportInterfaceConfigurationDay.Sunday)
    });
  }
}
